module.exports = __webpack_public_path__ + "static/media/wedding_party.7acb18e3.svg";